var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmJcb = function SvgPmJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.111 6H1.89C.846 6 0 6.82 0 7.833v18.334C0 27.179.846 28 1.889 28H32.11C33.154 28 34 27.18 34 26.167V7.833C34 6.821 33.154 6 32.111 6Z",
    fill: "#004099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.316 21.926a3.47 3.47 0 0 1-3.465 3.465H6V11.664A3.47 3.47 0 0 1 9.465 8.2h18.851v13.727Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.179 18.401h1.433c.04 0 .136-.013.176-.013a.642.642 0 0 0 .506-.642.662.662 0 0 0-.506-.642.72.72 0 0 0-.177-.013H22.18v1.31Z",
    fill: "#54B130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.448 9.36a2.483 2.483 0 0 0-2.483 2.482v2.578h3.506a1.41 1.41 0 0 1 .245.014c.792.041 1.375.45 1.375 1.16a1.16 1.16 0 0 1-1.132 1.132v.027c.805.055 1.42.505 1.42 1.201 0 .75-.683 1.241-1.583 1.241h-3.85v5.047h3.642a2.483 2.483 0 0 0 2.482-2.482V9.36h-3.622Z",
    fill: "#54B130"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.115 15.757a.58.58 0 0 0-.505-.587c-.027 0-.092-.014-.137-.014h-1.296v1.201h1.296a.38.38 0 0 0 .137-.014.58.58 0 0 0 .505-.586Z",
    fill: "#54B130"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.725 9.36a2.483 2.483 0 0 0-2.483 2.482v6.126a4.91 4.91 0 0 0 2.142.559 1.191 1.191 0 0 0 1.322-1.228v-2.893h2.128v2.879c0 1.118-.696 2.032-3.055 2.032-.86 0-1.717-.105-2.551-.313v5.225h3.642a2.483 2.483 0 0 0 2.482-2.483V9.36H9.725Z",
    fill: "#006BB9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.584 9.36a2.483 2.483 0 0 0-2.482 2.482v3.246a4.958 4.958 0 0 1 3.479-.79c.658.041 1.31.141 1.95.3v1.05a4.722 4.722 0 0 0-1.882-.55c-1.337-.092-2.142.559-2.142 1.705 0 1.145.805 1.814 2.142 1.705a4.95 4.95 0 0 0 1.883-.55v1.05c-.64.16-1.293.26-1.951.3a4.958 4.958 0 0 1-3.479-.791v5.729h3.642a2.483 2.483 0 0 0 2.482-2.482V9.359h-3.642Z",
    fill: "#E00137"
  })));
};
export default SvgPmJcb;